/* eslint-disable jsx-a11y/media-has-caption */
import * as React from "react";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";

import { playAudioEffect } from "../../../../store/audio-slice";
import { getAudio } from "../../../../utils/AudioUtils";
import { AudioEnum } from "../../../../enums";

const AudioPlayerInteractiveEffect: React.FC = () => {
  const audioEffectToBePlayed = useAppSelector(
    (state) => state.audio.audioEffectToBePlayed
  );
  const isMute = useAppSelector((state) => state.audio.isMute);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (audioEffectToBePlayed !== AudioEnum.NO_EFFECT || isMute) {
      setTimeout(() => {
        dispatch(playAudioEffect(AudioEnum.NO_EFFECT));
      }, 300);
    }
  }, [audioEffectToBePlayed, isMute, dispatch]);

  return (
    <>
      {audioEffectToBePlayed !== AudioEnum.NO_EFFECT && (
        <audio autoPlay muted={isMute}>
          <source src={getAudio(audioEffectToBePlayed)} />
        </audio>
      )}
    </>
  );
};

export default AudioPlayerInteractiveEffect;
